import React from 'react';
import useGameStore from '../../store/gameStore';
import './HistoryPanel.css';

function timeAgo(ts) {
  const s = Math.floor((Date.now() - ts) / 1000);
  if (s < 60)  return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s/60)}m ago`;
  return `${Math.floor(s/3600)}h ago`;
}

export default function HistoryPanel() {
  const { history } = useGameStore();

  if (history.length === 0) return null;

  return (
    <div className="history-panel">
      <h3 className="history-title">Recent Rounds</h3>
      <div className="history-list">
        {history.map((item, i) => (
          <div key={i} className={`history-item ${item.type}`}>
            <span className="hist-icon">
              {item.type === 'cashout' ? '💰' : '💀'}
            </span>
            <span className="hist-label">
              {item.type === 'cashout' ? `Cashed out step ${item.step}` : `Crashed step ${item.step + 1}`}
            </span>
            <span className={`hist-amount ${item.type === 'cashout' ? 'win' : 'lose'}`}>
              {item.type === 'cashout' ? '+' : '-'}{item.amount.toFixed(2)}
            </span>
            <span className="hist-time">{timeAgo(item.ts)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
